import { HttpErrorResponse } from '@angular/common/http';
import { isHttpTimeoutError } from '../models/http-timeout-error';

export function getSeverityByStatusCode(statusCode: number) {
  // A non-numeric status fails both comparisons below and would silently log as Warning. Treat an
  // unknown status as Error — the same hole getStatusClass had, which produced the string "NaNxx".
  if (!Number.isFinite(statusCode)) {
    return 3;
  }

  return statusCode >= 500 || statusCode === 0 ? 3 : 2;
}

/**
 * Telemetry bucket for a failed request.
 *
 * A client-side timeout has to be distinguishable from a network-down failure even though both
 * carry status 0, so the timeout is checked first.
 *
 * This also guards against a non-numeric status. The previous inline expression in
 * `AppInsightsInterceptor` was `err.status === 0 ? 'network' : ${Math.floor(err.status / 100)}xx`,
 * which emitted the literal string "NaNxx" for any error arriving without a numeric status — for
 * example a bare RxJS error escaping into the chain.
 */
export function getStatusClass(error: HttpErrorResponse): string {
  if (isHttpTimeoutError(error)) {
    return 'timeout';
  }

  if (!Number.isFinite(error.status) || error.status === 0) {
    return 'network';
  }

  return `${Math.floor(error.status / 100)}xx`;
}
